<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="updateDetail" @submit="submit" :updateData="updateDetail"></UPDATE>
    <UPDATE ref="productUpdate" @submit="submitProduct" :updateData="updateProductDetail"></UPDATE>

    <dialog-table-page ref="followers" :pageData="followers"></dialog-table-page>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import dialogTablePage from '@/components/page/dialogTable.vue'
import Qs from 'qs'
import Url from '@/views/merchandiser/util/url'
import UPDATE from '@/components/page/update'
import subscriptionInfo from '@/views/merchandiser/customer/subscribe_log_list'

let types = { 1: '新进信号源', 2: '历史信号源', 3: '不合格信号源' }//信号源属性
let statusArr = { 1: '啟用', 2: '禁用' }
let userType = { 1: '代理', 2: '標準', 3: '行家', 4: '大師', 5: '傳奇' }
let companyCodeName = {}, company = {},
  platformList = { 'MT5': 'MT5', 'GTS2': 'GTS2' }
let symbolType = { 2: '外汇', 3: '参考行情', 4: '商品', 5: '期指', 6: '货币', 7: '股票' }
let symbolField = [], signalFollowerList = []

export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE,
    dialogTablePage
  },
  mounted() {

  },
  created() {
    this.initCompanys()
  },
  methods: {
    initCompanys() {
      this.dataChange(Url.company.companyListAll, {}, res => {
        if (res.code == 0) {
          for (let i in res.result) {
            companyCodeName[res.result[i].companyId] = res.result[i].name
            company[res.result[i].companyId] = res.result[i]
          }
        } else {
          this.$message.error('加載公司列表失敗')
        }
      })
    },
    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      }
    },
    submit(model) {
      model.allowedPlatform = model.allowedPlatform.join(',')
      this.dataChange(Url.signal.sourceEdit, model, res => {
        if (res.code == 0) {
          this.$refs.updateDetail.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    submitProduct(row) {
      row.symbols = []
      for (let i = 0; i < symbolField.length; i++) {
        if (row[symbolField[i]] && row[symbolField[i]].length > 0) row.symbols = row.symbols.concat(row[symbolField[i]])
      }
      row.symbols = row.symbols.map(col => {
        return col.symbol
      }).join(',')
      this.dataChange(Url.signal.productEdit, row, res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$refs.productUpdate.close()
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    bthClick(clickName, row) {
      if (clickName == 'sourceDetail') {//查看信号源交易详情
        row.allowedPlatform = row.allowedPlatform.split(',')
        this.$refs.updateDetail.open(row)
      } else if (clickName == 'productEdit') {
        this.productEdit(row)
      } else if (clickName == 'status') {
        this.status(row)
      } else if (clickName == 'del') {
        this.del(row)
      } else if (clickName == 'subscribeList') {
        this.subscribeList(row)
      } else if (clickName == 'closeSummary') {
        this.closeSummary(row)
      }
    },
    closeSummary(row) {
      this.dataChange(Url.signal.closeSummary, { 'unique': row.uniqueKey }, res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    subscribeList(row) {
      if (row.nowTrack <= 0) return
      this.followers.sync = true
      let data = { 'signalKey': row.uniqueKey }
      this.$refs.followers.defaultQueryData(data)
    },
    status(row) {
      this.dataChange(Url.signal.sourceStatus, row, res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    del(row) {
      this.dataChange(Url.signal.sourceDel, row, res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    productEdit(row) {
      this.dataChange(Url.signal.productList, row, res => {
        symbolField = []
        if (res.code == 0) {
          row.symbols = res.result.symbol
          this.updateProductDetail.cols = [
            { title: 'uniqueKey', field: 'uniqueKey', required: true, readonly: true },
            { title: '指派公司', field: 'assigningCompanyId', required: true, isNumber: true, readonly: true },
            { title: '指派业务', field: 'assigningBusinessType', required: true, readonly: true },
            { title: '支持平台', field: 'platform', required: true, readonly: true },
            { title: '产品类型', field: 'symbolType', type: 3, optionList: symbolType, button: true, required: true }
          ]
          for (let i in res.result) {
            let optionList = []
            let select = []
            const symbolArr = res.result[i]
            for (let j in symbolArr) {
              optionList.push({ 'symbol': symbolArr[j].symbol })
              if (symbolArr[j].checked) {
                select.push(j)
              }
            }
            let field = 'product' + i
            symbolField.push(field)
            let col = {
              title: symbolType[i], field: field, type: 18, pageData: {
                selection: true,
                isPage: false,
                cols: [
                  { title: '产品', field: 'symbol' }
                ]
              }, optionList: optionList, data: [], selectList: select, hidden: (model, col) => {
                return model.symbolType != i
              }
            }
            this.updateProductDetail.cols.push(col)
          }
          this.$refs.productUpdate.open(row)
        } else {
          this.$message.error(res.message)
        }
      }, res => {
        console.log(res)
      })
    },
    businessType(model) {
      let assigningCompanyId = model.assigningCompanyId
      let result = {}
      if (assigningCompanyId != undefined && assigningCompanyId != null) {
        let businessTypes = company[assigningCompanyId].businessTypes.split(',')
        for (const i in businessTypes) {
          result[businessTypes[i]] = businessTypes[i]
        }
      }
      return result
    }
  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '信号源', field: 'customerNumber' },
          { title: 'accountId', field: 'accountId' },
          { title: '信号源所属公司', field: 'companyId' },
          { title: '信号源所属业务', field: 'businessType' },
          { title: '指派公司', field: 'assigningCompanyId' },
          { title: '指派业务', field: 'assigningBusinessType' },
          { title: '狀態', field: 'status', type: 2, optionList: statusArr },

          { click: window.$t('common.search') }
        ]
      },

      followers: {
        queryUrl: Url.signal.subscribeFollowers, //请求路径和参数
        title: '跟隨人員',
        sync: false,
        isShow: false,
        sequence: true,
        isPage: false,
        cols: [
          { title: '賬號', field: 'customerNumber' },
          { title: 'accountId', field: 'accountId' },
          { title: '公司', field: 'companyId' },
          { title: '業務', field: 'businessType' },
          {
            title: '時間', field: 'createTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          }
        ]
      },

      updateProductDetail: {
        cols: [
          { title: '唯一鍵', field: 'uniqueKey', required: true, readonly: true },
          { title: '所屬平台', field: 'platform', required: true, readonly: true },
          { title: '指派公司', field: 'assigningCompanyId', required: true, isNumber: true, readonly: true },
          { title: '指派业务', field: 'assigningBusinessType', required: true, readonly: true },
          { title: '支持平台', field: 'allowedPlatform', required: true, readonly: true },
          { title: '产品类型', field: 'symbolType', type: 3, optionList: symbolType, button: true, required: true }
        ]
      }
      ,
      updateDetail: {
        cols: [
          { title: '唯一鍵', field: 'uniqueKey', hidden: true },
          { title: 'id', field: 'id', hidden: true },
          { title: '信号源交易账号', field: 'customerNumber', required: true, readonly: true, remarkTxt: '此字段不能修改' },
          { title: '信号源所属公司', field: 'companyId', required: true, readonly: true, remarkTxt: '此字段不能修改' },
          { title: '信號源平台', field: 'platform' },
          { title: '信号源所属业务', field: 'businessType', readonly: true, remarkTxt: '此字段不能修改' },
          {
            title: '指派公司',
            field: 'assigningCompanyId',
            required: true,
            readonly: true,
            type: 2,
            isNumber: true,
            remarkTxt: '此字段不能修改',
            optionList: companyCodeName
          },
          {
            title: '指派业务',
            field: 'assigningBusinessType',
            required: true,
            type: 2,
            optionListObjRender: (model, col) => {
              return this.businessType(model)
            }
          },
          { title: '初始跟单人数', field: 'initTrack', required: true },
          { title: '最多允许跟单人数', field: 'maxTrack', required: true },
          { title: '支持平台', field: 'allowedPlatform', required: true, type: 4, optionList: platformList, data: [] },
          { title: 'UI端昵称', field: 'nickName', required: true },
          { title: '头像', field: 'imgUrl', required: true },
          { title: '信号源类型', field: 'userType', required: true, type: 2, optionList: userType,isNumber: true },
          { title: '利润分成', field: 'profitSharing', required: true, isNumber: true },
          { title: '简介', field: 'remark' }
        ]
      }
      ,
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.signal.sourceList,
        selection: false,
        sequence: true,
        size: 10,
        method: 'get',
        cols:
          [
            { title: 'uniqueKey', field: 'uniqueKey' },
            { title: 'accountId', field: 'accountId' },
            { title: '信号源交易账号', field: 'customerNumber' },
            { title: '信号源所属公司', field: 'companyId' },
            { title: 'nickName', field: 'nickName' },
            { title: '信号源所属业务', field: 'businessType' },
            { title: '信号源所属平台', field: 'platform' },
            { title: '支持平台', field: 'allowedPlatform' },
            { title: '指派公司', field: 'assigningCompanyId' },
            { title: '指派业务', field: 'assigningBusinessType' },
            { title: '允许跟单人数', field: 'maxTrack' },
            { title: '初始跟單人數', field: 'initTrack' },
            { title: '已跟单人数', field: 'nowTrack', h5Click: 'subscribeList' },
            {
              title: '是否启用', field: 'status', render: (data, full) => {
                return statusArr[data]
              }
            },
            {
              title: '屬性更新', field: 'updateTime', render: (data, full) => {
                return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
              }
            },
            {
              title: '信号源类型', field: 'userType', render: (data, full) => {
                return userType[data]
              }
            },
            { title: '利润分成', field: 'profitSharing' },
            { title: 'symbols', field: 'symbols' },
            {
              title: '操作',
              btnClick: [
                {
                  name: '交易屬性生成',
                  click: 'closeSummary'
                },
                {
                  name: '允许跟单产品',
                  click: 'productEdit'
                },
                {
                  name: '編輯',
                  click: 'sourceDetail',
                  type: 'primary',
                  icon: 'el-icon-edit',
                  auth: 'source:info:edit'
                },
                {
                  name: '開/禁',
                  click: 'status',
                  type: 'primary',
                  icon: 'el-icon-add',
                  auth: 'signal:source:cancel'
                },
                {
                  name: '移除',
                  click: 'del',
                  type: 'primary',
                  icon: 'el-icon-add',
                  auth: 'signal:source:del'
                }]
            }
          ]
      }
    }
  }
}
</script>
